var map = {
	"./circle-open.jsx": [
		1370,
		370
	],
	"./circle.jsx": [
		6235,
		235
	],
	"./live-help.jsx": [
		6749,
		749
	],
	"./premium-lock.jsx": [
		4006,
		6
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6519;
module.exports = webpackAsyncContext;